<template>
  <form
    class="
      general-configuration
      custom-form
      h-100
      d-flex
      flex-column
      animate__animated animate__fadeIn
    "
    @submit.prevent="save"
    novalidate
  >
    <h2 class="section-subtitle">Códigos javascripts</h2>

    <div class="form-container border-bottom-0">
      <div class="form-group d-flex flex-column flex-md-row">
        <div class="label-container">
          <label for="header">Header</label>
        </div>

        <div class="form-field">
          <textarea
            id="header"
            placeholder="Ingresar códigos para header"
            class="custom-form-control"
            v-model="form[0].value"
          ></textarea>
        </div>
      </div>

      <div class="form-group d-flex flex-column flex-md-row">
        <div class="label-container">
          <label for="header">Footer</label>
        </div>

        <div class="form-field">
          <textarea
            id="footer"
            placeholder="Ingresar códigos para footer"
            class="custom-form-control"
            v-model="form[1].value"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="form-group-buttons text-right mt-auto mb-0">
      <button class="button button-primary" type="submit">Guardar</button>
    </div>
  </form>
</template>

<script>
import { ConfigurationService } from "@/core/services";

import { Alert } from "@wizepe/wize-admin";

export default {
  data() {
    return {
      // form: {
      //   header: null,
      //   footer: null
      // },
      form: [
        {
          identifier: "JS_HEADER",
          value: null,
        },
        {
          identifier: "JS_FOOTER",
          value: null,
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async save() {
      // this.$v.$touch();
      // if (this.$v.$error) return;

      try {
        this.$store.commit("app/setLoading", true);

        const params = this.form.map((item) => {
          return {
            identifier: item.identifier,
            value: item.value ? item.value : "",
          };
        });

        const resp = await ConfigurationService.save(params);

        if (resp.status === "OK") {
          Alert.success("Se ha realizado la actualización correctamente");
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);
        const response = await ConfigurationService.list();
        let data = response.payload;
        this.form.forEach((item) => {
          let field = data.find((d) => d.identifier == item.identifier);
          if (field) {
            item.value = field.value;
          }
        });
      } catch (error) {
        console.error(error);
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../Styles/general-configuration.styl';
</style>
